// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Qk8V","name":"styles_name__jmpE4","phone":"styles_phone__373G5"};